import React, { Component, Fragment } from 'react';
import "../../../index.css";
import { withTranslation } from 'react-i18next';
import * as constants from "../constants";
import FilterHelper from "../../../helpers/filterHelper"; 
import { SearchList } from "./searchList";
import axios from 'axios';
import Spinner from '../CircularSpinner';
import StatefulSessionHelper from "../../../helpers/statefulSessionHelper";
import DoneIcon from '@material-ui/icons/Done';
import PasswordModal from "../passwordModal";
                    

var isMounted = false;

export class UsersManagementList  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows : [],
            filter: "",
            filterOptions : [],
            builderList : [],
            isLoading : false,
            isRowStyle : false,
            expandedSearch: false,
            idSaveLocal: this.props.idSave !== undefined ? this.props.idSave : constants.usersManagementFilter,
            openPassword: false,
            userPasswordId: ""
        }
    }

    componentWillUnmount() {
        isMounted = false;
        this.props.cancelPromises();
    }

    componentDidMount() {
        this.setFilter();
        var searchValue = StatefulSessionHelper.getSearchValue(this.state.idSaveLocal + this.props.user.profile.sub);
        if (searchValue === null) {
            searchValue = "";
        }

        this.setState({
            filter : searchValue
        }, function() {
            this.reloadData();
        })
      
    }

    reloadData = () => {
        var data = FilterHelper.getfilterOptions(this.state.idSaveLocal);
        this.loadRecords(this.state.filter, data.sort,1);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.users !== this.props.users) {
            this.setState({
                rows : this.props.users,
            });
        }

    }
    
    setFilter = () => {
        this.setState({
            idSave : this.props.idSave,
        });

        var options = [
            FilterHelper.createFilterOption("username", true, true, 2, constants.textAlign.left, true, null, "Username"),
            FilterHelper.createFilterOption("firstName", true, false, 2, constants.textAlign.left, true, null, "FirstName"),
            FilterHelper.createFilterOption("lastName", true, false, 2, constants.textAlign.left, true, null, "LastName"),
            FilterHelper.createFilterOption("email", true, false, 2, constants.textAlign.left, true),
            FilterHelper.createFilterOption("enabled", true, false, 2, constants.textAlign.left, false),
        ];

        var filterOptions = FilterHelper.setFilter(this.state.idSaveLocal, options, false);
        this.setState({
            filterOptions : filterOptions.filter,
            isRowStyle : filterOptions.isRowStyle
        })
    }

    showFilterFields = (row, rowFilter) => {
        return (
            <Fragment>
                {rowFilter.id === "username" &&
                    row.username
                }
                 {rowFilter.id === "firstName" &&
                    row.firstName
                }
                {rowFilter.id === "lastName" &&
                    row.lastName
                }
                {rowFilter.id === "email" &&
                    row.email
                }
                {rowFilter.id === "enabled" &&
                    <Fragment>
                        {row.enabled &&
                            <DoneIcon/>
                        }
                    </Fragment>
                }


            </Fragment>
        )
    }

    loadRecords = async (filter, sort, page) => {
        isMounted = true;

        this.props.cancelPromises();

        var isLoaded = false;
        if (!this.props.isArray) {

            
            if (!this.props.isLoading) {
                this.setState({
                    isLoading : true
                })
            }

            var data = FilterHelper.getfilterOptions(this.state.idSaveLocal);
            this.setState({
                filterOptions : data.filter,
                isRowStyle: data.isRowStyle 
            })
            const cancelToken = axios.CancelToken.source();

            await this.props.cancellablePromise(
               this.props.actions.ReadUsers( filter, data.sort, page, cancelToken.token), cancelToken
            )
            .then(() => {
                isLoaded = true;
            })
            .catch((error) => {
                if (error.message === constants.cancelHttpRequest || error.message === "[object Object]") {
                    isMounted = false;
                }
            })
            .finally(result =>{
                if (isMounted) {
                    this.setState({
                        isLoading : false
                    })
                }
            })
        }
        else {
            this.props.loadRecords(filter, sort);
        }

        return isLoaded;
    }
    
    handleDeleteRow = async (record) => {
        if (!this.props.isLoading) {
            this.setState({
                isLoading : true
            })
        }

        record.state = constants.Deleted;
        var data = {...record};

        if (this.props.isTesting) {
            this.setState({
                recordTest : data
            });
        }
      
        var isDeleted = false;
        await this.props.actions.deleteUser(data.id)
        .then(() => {
            isDeleted = true;
        })
        .catch(() => {})
        .finally(() =>{
            this.setState({
                isLoading : false
            })
        })
        return isDeleted;
    }

    passwordEvent = (e, idx) => {

        this.setState({
            userPasswordId: this.state.rows[idx].id,
            openPassword : true
        })
    }

    handlePassword = () => {
        this.setState({
            openPassword : false
        })
    }

    render() {
        const { t } = this.props;
        return (
            <Fragment>
                {this.state.isLoadingMassive &&
                    <Spinner open={true}/>
                }
                <SearchList 
                    {...this.props}
                    rows={this.state.rows}
                    showFilterFields={this.showFilterFields}
                    filterOptions={this.state.filterOptions}
                    isRowStyle={this.state.isRowStyle}
                    loadRecords={this.loadRecords}
                    handleDeleteRow={this.handleDeleteRow}
                
                   
                    backButton={this.props.backButton !== undefined ? this.props.backButton : false}
                    onlySelect={this.props.onlySelect !== undefined ? this.props.onlySelect :  false}
                    addButton={this.props.addButton !== undefined ? this.props.addButton : true}
                    deleteButton={this.props.deleteButton !== undefined ? this.props.deleteButton  : true}
                    editButton={this.props.editButton !== undefined ? this.props.editButton : true}
                    isToUp={this.props.isToUp !== undefined ? this.props.isToUp : true}
                    title={t(this.props.title !== undefined ? this.props.title : "Users")} 
                    pathBackFromAddEdit={this.props.pathBackFromAddEdit !== undefined ? this.props.pathBackFromAddEdit : "/usersManagementList/"}
                    pathAddEdit={this.props.pathAddEdit !== undefined ? this.props.pathAddEdit : "/usersManagement/"}
                    isLoading={this.state.isLoading}
                    handleOneSelect={this.props.handleOneSelect}
                    handleSearchOneSelect={this.props.handleSearchOneSelect}
                    multiSelect={this.props.multiSelect}
                
                    isArray={this.props.isArray}
                    handleAdd={this.props.handleAdd}
                    refreshDetails={this.props.refreshDetails}
                    builderList={this.state.builderList}
                    idSave={this.props.idSave !== undefined ? this.props.idSave : constants.usersManagementFilter  }
                    handleCloseProduct={this.props.handleCloseProduct}
                    history={this.props.history}
                    expandedSearch={this.state.expandedSearch}
                    passwordEvent={this.passwordEvent}

                />
                { this.state.openPassword &&
                   <PasswordModal
                        open={this.state.openPassword}
                        userId={this.state.userPasswordId}
                        handleReply={this.handlePassword}
                        t={this.props.t}
                   >
                   </PasswordModal>
                } 
            </Fragment>    
        )
    };
}

export default withTranslation('common')(UsersManagementList);
